import { css } from "styled-system/css";

/** Konkord: a part of the small profile card, without a box around it */
export const section = css({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  minWidth: 0,
});

export const sectionTitle = css({
  fontSize: "11px",
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: "var(--md-sys-color-on-surface-variant)",
});

/** A few lines, the rest is on the full profile */
export const clamped = css({
  lineClamp: 5,
  cursor: "pointer",
});
